import {
  type ASTNode,
  type FieldNode,
  type FragmentDefinitionNode,
  type VariableNode,
} from 'graphql';

type Node = ASTNode | readonly ASTNode[] | undefined;

export const getKind = (node: Node) => (node instanceof Array ? undefined : node?.kind);

export const getName = (node: Node) => {
  if (Array.isArray(node)) {
    return;
  }

  if (isFragmentNode(node)) {
    return node.typeCondition.name.value;
  }

  // @ts-ignore
  return node?.name?.value;
};

export const isFieldNode = (node: Node): node is FieldNode => getKind(node) === 'Field';
export const isFragmentNode = (node: Node): node is FragmentDefinitionNode =>
  getKind(node) === 'FragmentDefinition';
export const isVariableNode = (node: Node): node is VariableNode =>
  getKind(node) === 'FragmentDefinition';
